import { render, staticRenderFns } from "./ContactNotes.vue?vue&type=template&id=5c9509bc&scoped=true&lang=true"
import script from "./ContactNotes.vue?vue&type=script&lang=js"
export * from "./ContactNotes.vue?vue&type=script&lang=js"
import style0 from "./ContactNotes.vue?vue&type=style&index=0&id=5c9509bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9509bc",
  null
  
)

export default component.exports